import { acceptHMRUpdate, defineStore } from "pinia";
import { popupStoreData } from "@core/ui/popupDialog.store";

import { i18n } from "@/i18n";
import type { ActionItem } from "@editor/items/action/ActionItem";
import type { MomentumItem } from "@editor/items/momentum/MomentumItem";
import type { IncidentItem } from "@editor/items/incident/IncidentItem";
import type { RelationItem } from "@editor/items/relation/RelationItem";

type SimulationMessageItem = {
  type: string;
  text?: string;
  imageId?: number | null;
  webLink?: { url: string; text: string };
} | ActionItem | MomentumItem | IncidentItem | RelationItem;

export const useSimulationMessage = defineStore("ui/simulationMessage", {
  state: () => ({
    ...popupStoreData.state(),

    item: null as null | SimulationMessageItem,
    round: null as null | object,
    title: "",
    type: "",
    buttonText: i18n.t("labels.ok"),
    ignoreGetter: null as null | (() => boolean),
    ignoreSetter: null as null | ((val: boolean) => void),
    class: ""
  }),
  actions: {
    ...popupStoreData.actions,

    show(options: {
      type?: string;
      title?: string | null;
      buttonText?: string | null;
      item?: null | SimulationMessageItem;
      round?: null | object;
      class?: string;
      ignoreGetter?: () => boolean;
      ignoreSetter?: (val: boolean) => void;
    }) {
      if (options.buttonText == null) {
        options.buttonText = i18n.t("labels.ok");
      }
      this.set(options);
      return this.open();
    },
    hide(data?: unknown) {
      const returnValue = this.close(data);
      this.$reset();
      return returnValue;
    },
    set(options: { [key: string]: unknown }) {
      this.$patch((state) => {
        Object.assign(state, options);
      });
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useSimulationMessage, import.meta.hot)
  );
}
